import React, { useEffect, useMemo, useRef, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axiosInstance from '../../../axios';
import { Menu, Text, Button, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import {toast} from 'react-toastify'
import * as XLSX from 'xlsx';
const Example = ({
  batchPhase,
  batch,
  state,
  district,
  year,
  scheme,
  sector,
  jobRole,
  reportType,
  type,
  centre,
  start,
  end,
  generateClicked,
}) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const [day, month, year] = new Date(dateString)
      .toLocaleDateString('en-GB', options)
      .split('/');
    return `${day}-${month}-${year}`;
  };
  // Date formatting function
const formatDateForExcel = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB'); // Format as dd/mm/yyyy
};

  const [batchData, setBatchData] = useState({});
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  const rowVirtualizerInstanceRef = useRef(null);
  const navigate = useNavigate();
  const getFY = (date) => {
    const d = new Date(date); 
    return d.getFullYear()
  }
  // Columns definition
  const columns = useMemo(
    () => [
      { id: 'financial_year',accessorKey: 'start_date', header: 'Financial Year', Cell: ({ row }) => {
        const start = new Date(row.original.start_date).getFullYear();
        const end = new Date(row.original.end_date).getFullYear();
        return `${start}-${end}`;
      } },
      { accessorKey: 'scheme_name', header: 'Scheme Name' },
      { accessorKey:'training_type',header:'STT/RPL'},
      { accessorKey: 'state', header: 'State' },
      { accessorKey: 'district', header: 'District' },
      { accessorKey: 'centre_name', header: 'Centre Name' },
      { accessorKey: 'vtp_id', header: 'TC ID' },
      { accessorKey: 'sector_name', header: 'Sector Name' },
      { accessorKey: 'job_role_name', header: 'Job Role Name' },
      { accessorKey: 'tbn_no', header: 'Batch Id/TBN No.' },
      { accessorKey: 'batch_name', header: 'Batch Name' },
      { accessorKey: 'batch_type', header: 'Batch Type' },
      { accessorKey: 'batch_phase', header: 'Batch Phase' },
      { id: 'start_date', accessorKey: 'start_date', header: 'Start Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
      { accessorKey: 'end_date', header: 'End Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
      { accessorKey: 'capacity', header: 'TC Capacity' },
      { accessorKey: 'to_enrolled_no', header: 'Batch Size' },
      { accessorKey: 'status', header: 'Status' },
      { accessorKey: 'trainer_names', header: 'Trainer Name' },
      { accessorKey: 'trainer_code' ,header:'Trainer Code'},
      { accessorKey: 'trainer_aadhar_no',header: 'Trainer Aadhar No.'},
      { accessorKey: 'trainer_contact', header: 'Trainer Contact No.' },
      { accessorKey: 'address', header: 'Trainer Address' },
      { accessorKey: 'assest_by', header: 'Assessed By' },
      { accessorKey: 'assesment_id', header: 'Assessment ID' },
      { accessorKey: 'assesment_date', header: 'Assessment Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
      { accessorKey: 'study_material_distribution', header: 'Study Material Distribution' },
      { accessorKey: 'uniform_distribution', header: 'Uniform Distribution' },
      { accessorKey: 'pass_students', header: 'Total Pass' },
      { accessorKey: 'fail_students', header: 'Total Fail' },
      { accessorKey: 'dropout_students', header : 'Total Dropout' },
      { accessorKey: 'self_employed_students', header: 'Self Employed Count' },
      { accessorKey: 'wages_students', header: 'Wages Employed Count' },
      { accessorKey: 'placed_students', header: 'Total Placed Count' },
    ],
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post('/batch/summaryReport', {
          centre_id: centre,
          scheme_id: scheme,
          start_date: start,
          end_date: end,
          financial_year: year,
          sector_id: sector,
          job_role_name: jobRole,
          state,
          district,
          batch_type: batchPhase,
          tbn_no: batch,
          type,
        });
        //console.log(response.data);
        setData(response.data.batch_data);
        setBatchData(response.data.total_batches);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [generateClicked]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item
          onClick={() =>
            navigate(
              `/batches/details`,
              {
                state: { id: row.original.batch_id },
              },
              { replace: true }
            )
          }
        >
          Details
        </Menu.Item>
        <Menu.Item
          onClick={() =>
            navigate(`/batches/students`, {
              state: { id: row.original.batch_id },
            })
          }
        >
          View Students
        </Menu.Item>
      </>
    ),
  });
  const headerMapping = {
    sr_no: 'Sr No',
    financial_year:'Financial Year',
    scheme_name: 'Scheme Name',
    rpl_type: 'STT/RPL',
    state: 'State',
    district: 'District',
    centre_name: 'TC Name',
    vtp_id: 'TC ID',
    sector_name: 'Sector Name',
    job_role_name: 'Job Role Name',
    tbn_no: 'Batch Id/TBN No.',
    batch_name: 'Batch Name',
    batch_type: 'Batch Type',
    batch_phase: 'Batch Phase',
    start_date: 'Start Date',
    end_date: 'End Date',
    capacity: ' TC Capacity',
    to_enrolled_no:'Batch Size',
    status: 'Status',
    trainer_names: 'Trainer Name',
    trainer_code:'Trainer Code',
    trainer_aadhar:'Trainer Aadhar No',
    trainer_contact:'Trainer Contact No.',
    trainer_address:'Trainer Address',
    assest_by: 'Assessed By',
    assesment_id: 'Assessment ID',
    assesment_date: 'Assessment Date',
    study_material_distribution: 'Study Material Distribution',
    uniform_distribution: 'Uniform Distribution',
    total_pass: 'Total Pass',
    total_fail: 'Total Fail',
    total_dropout: 'Total Dropout',
    self_employed_students: 'Self Employed Count',
    wages_students: 'Wages Employed Count',
    placed_students: 'Total Placed Count',
  };
  const exportToExcel = () => {
    const filteredData = table.getFilteredRowModel().rows.map(({ original }, index) => ({
      sr_no: index + 1,
      financial_year: year || `${new Date(original.start_date).getFullYear()} - ${new Date(original.end_date).getFullYear()} `,
      scheme_name: original.scheme_name,
      rpl_type: original.training_type,
      state: original.state,
      district: original.district,
      centre_name: original.centre_name,
      vtp_id: original.vtp_id,
      sector_name: original.sector_name,
      job_role_name: original.job_role_name,
      tbn_no: original.tbn_no,
      batch_name: original.batch_name,
      batch_type: original.batch_type,
      batch_phase: original.batch_phase,
      start_date: formatDateForExcel(original.start_date),
      end_date: formatDateForExcel(original.end_date),
      capacity: original.capacity,
      to_enrolled_no: original.to_enrolled_no,
      status: original.status,
      trainer_names: original.trainer_names,
      trainer_code:original.trainer_code,
      trainer_aadhar:original.trainer_aadhar_no,
      trainer_contact:original.trainer_contact,
      trainer_address:original.address,
      assest_by: original.assest_by,
      assesment_id: original.assesment_id,
      assesment_date: formatDateForExcel(original.assesment_date),
      study_material_distribution: original.study_material_distribution,
      uniform_distribution: original.uniform_distribution,
      total_pass: original.pass_students,
      total_fail: original.fail_students,
      total_dropout: original.dropout_students,
      self_employed_students: original.self_employed_students,
      wages_students: original.wages_students,
      placed_students: original.placed_students,
    }));
  
    if (filteredData.length === 0) {
      toast.error("No data to export! Please apply a valid filter.");
      return;
    }
  
    const ws = XLSX.utils.json_to_sheet(filteredData, { header: Object.keys(headerMapping) });
    ws['!cols'] = Object.keys(headerMapping).map(() => ({ wpx: 120 })); // Set column widths
    const newHeaders = Object.values(headerMapping);
    newHeaders.forEach((header, index) => {
      ws[XLSX.utils.encode_cell({ r: 0, c: index })].v = header;
    });
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Batch Report');
    XLSX.writeFile(wb, 'Batch Summary Report.xlsx');
  };
  return (
    <Paper shadow="sm" p="lg" withBorder>
      <div className="flex justify-between mb-2">
        <Text weight={500} size="lg" className="text-sky-700">
          Total Batches : {batchData.total_batches}
        </Text>
        <Button color='green' onClick={exportToExcel}>Export to Excel</Button>
      </div>
      <div className="flex justify-between">
        <Text className="text-gray-600">Created: {batchData.created_batches}</Text>
        <Text className="text-green-600">Assessment Completed: {batchData.assessment_completed_batches}</Text>
        <Text className="text-yellow-600">InProgress Batches: {batchData.in_progress_batches}</Text>
        <Text className="text-lime-600">Placement Completed: {batchData.placement_completed_batches}</Text>
        <Text className="text-rose-600">Under Assessment: {batchData.under_assessment_batches}</Text>
      </div>

      <MantineReactTable
        table={table}
        striped
        highlightOnHover
        horizontalSpacing="md"
        verticalSpacing="sm"
        fontSize="sm"
        withColumnBorders
        borderRadius="md"
        withGlobalFilter
        height={400}
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        enablePagination={true}
      />
    </Paper>
  );
};

export default Example;
